// extracted by mini-css-extract-plugin
export var fadeIn = "_80-0";
export var panelInner = "_80-2";
export var panelOuter = "_80-1";